/**
 * Generated runtime TestId mirror for frontend/src/components/attributes/TypeScopeFilter.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const TypeScopeFilterTestIds = {
  typeScopeAll: "type-scope-all",
  typeScopeGlobal: "type-scope-global",
  typeScope: (type_code: string) => `type-scope-${type_code}`,
  typeScopePrefix: () => "type-scope-" as TestIdPrefix
} as const;
